<div class="backdrop">
    <div class="loader"></div>
</div>